// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("./IconV5.bs.js");
let Link = require("next/link").default;
let TailwindMerge = require("tailwind-merge");
let TailwindVariants = require("../../bindings/TailwindVariants.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let TailwindVariants$1 = require("tailwind-variants");
let ReactAriaComponents = require("react-aria-components");

let buttonBase = TailwindVariants$1.tv({
  extend: TailwindVariants.Utils.focusRing,
  base: "inline-flex shadow-none font-normal text-center items-center justify-center border border-solid duration-150 cursor-pointer whitespace-nowrap relative bg-transparent \n    disabled:pointer-events-none aria-disabled:pointer-events-none rounded-md",
  variants: {
    size: {
      small: "text-[13px] font-medium px-2.5 py-1 min-h-8",
      medium: "text-base font-semibold px-[15px] py-1.5 uppercase",
      large: "text-base font-semibold px-5 py-1.5 uppercase",
      huge: "text-lg font-semibold px-10 py-2 uppercase"
    }
  }
});

let buttonPrimary = TailwindVariants$1.tv({
  extend: buttonBase,
  base: "bg-tan-blue-500 text-white border border-tan-blue-500 hover:border-tan-gold-light hover:bg-tan-gold-light hover:text-white focus:text-white \n      disabled:border-transparent aria-disabled:border-transparent \n      disabled:bg-tan-blue-500/50 aria-disabled:bg-tan-blue-500/50"
});

let buttonSecondary = TailwindVariants$1.tv({
  extend: buttonBase,
  base: "border-zinc-300 text-zinc-600 bg-white hover:border-tan-blue-500 hover:text-white hover:bg-tan-blue-500 \n      disabled:border-zinc-300/50 aria-disabled:border-zinc-300/50 \n      disabled:text-zinc-600/50 aria-disabled:text-zinc-600/50 \n      disabled:bg-white/50 aria-disabled:bg-white/50"
});

let buttonDarkSecondary = TailwindVariants$1.tv({
  extend: buttonBase,
  base: "border-tan-big-stone-alt text-zinc-300 bg-tan-big-stone-alt hover:border-tan-blue-500 hover:text-white hover:bg-tan-blue-500 \n      disabled:border-tan-big-stone-alt/50 aria-disabled:border-tan-big-stone-alt/50 \n      disabled:text-zinc-300/50 aria-disabled:text-zinc-300/50 \n      disabled:bg-tan-big-stone-alt/50 aria-disabled:bg-tan-big-stone-alt/50"
});

let buttonCta = TailwindVariants$1.tv({
  extend: buttonBase,
  base: "border-tan-gold-light text-white bg-tan-gold-light hover:border-tan-gold-light hover:text-tan-gold-light hover:bg-white \n      disabled:border-transparent aria-disabled:border-transparent\n      disabled:bg-tan-gold-light/50 aria-disabled:bg-tan-gold-light/50"
});

let buttonLink = TailwindVariants$1.tv({
  extend: TailwindVariants.Utils.focusRing,
  base: "text-tan-blue-500"
});

let buttonDanger = TailwindVariants$1.tv({
  extend: buttonBase,
  base: "bg-tan-error-500 border-tan-error-500 text-white hover:border-tan-error-700 hover:bg-tan-error-700 hover:text-white focus:text-white \n      disabled:border-transparent aria-disabled:border-transparent\n      disabled:bg-tan-error-500/50 aria-disabled:bg-tan-error-500/50"
});

let buttonOutline = TailwindVariants$1.tv({
  extend: buttonBase
});

function ButtonsV5$BaseButton(props) {
  let styleFn = props.styleFn;
  let appearance = props.appearance;
  let __children = props.children;
  let ___type = props._type;
  let id = props.id;
  let ariaExpanded = props.ariaExpanded;
  let overlayText = props.overlayText;
  let icon = props.icon;
  let __className = props.className;
  let __size = props.size;
  let disabled = props.disabled;
  let onBlur = props.onBlur;
  let onFocus = props.onFocus;
  let onMouseEnter = props.onMouseEnter;
  let onClick = props.onClick;
  let tabIndex = props.tabIndex;
  let href = props.href;
  let size = __size !== undefined ? __size : "medium";
  let className = __className !== undefined ? __className : "";
  let _type = ___type !== undefined ? ___type : "submit";
  let children = __children !== undefined ? __children : null;
  let content = JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      icon !== undefined ? JsxRuntime.jsx(IconV5.make, {
          icon: icon,
          className: "mr-2.5"
        }) : null,
      overlayText !== undefined ? JsxRuntime.jsx("div", {
          children: overlayText,
          className: TailwindMerge.twMerge([
            "absolute bg-tan-gold-light text-white uppercase text-[10px] leading-[1.2] rounded-[3px] py-[1px] px-1.5 border border-tan-gold-light top-0 right-0 whitespace-nowrap translate-x-[10%] -translate-y-1/2",
            appearance !== undefined ? (
                appearance === "cta" ? "bg-white text-tan-gold-light border border-tan-gold-light" : (
                    appearance === "primary" ? "bg-white text-tan-blue-500 border border-tan-blue-500" : ""
                  )
              ) : ""
          ])
        }) : null,
      children
    ]
  });
  if (href !== undefined) {
    return JsxRuntime.jsx(Link, {
      href: disabled === true ? "#" : href,
      className: TailwindMerge.twMerge([
        styleFn({
          size: size,
          isFocusVisible: false
        }),
        className
      ]),
      "aria-disabled": disabled,
      onFocus: onFocus,
      onBlur: onBlur,
      tabIndex: tabIndex,
      children: content,
      target: props.target,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      disabled: disabled,
      "aria-expanded": ariaExpanded,
      id: id
    });
  } else {
    return JsxRuntime.jsx(ReactAriaComponents.Button, {
      children: content,
      className: state => TailwindMerge.twMerge([
        styleFn({
          size: size,
          isFocusVisible: state.isFocusVisible
        }),
        className
      ]),
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onFocus: onFocus,
      onBlur: onBlur,
      isDisabled: disabled,
      tabIndex: tabIndex,
      ariaExpanded: ariaExpanded,
      id: id,
      type: _type
    });
  }
}

function ButtonsV5$Button(props) {
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
    href: props.href,
    target: props.target,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    disabled: props.disabled,
    size: props.size,
    className: className,
    icon: props.icon,
    overlayText: props.overlayText,
    ariaExpanded: props.ariaExpanded,
    id: props.id,
    _type: props._type,
    children: children,
    styleFn: buttonBase
  });
}

let Button = {
  make: ButtonsV5$Button
};

function ButtonsV5$PrimaryButton(props) {
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
    href: props.href,
    target: props.target,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    disabled: props.disabled,
    size: props.size,
    className: className,
    icon: props.icon,
    overlayText: props.overlayText,
    ariaExpanded: props.ariaExpanded,
    id: props.id,
    _type: props._type,
    children: children,
    appearance: "primary",
    styleFn: buttonPrimary
  });
}

let PrimaryButton = {
  make: ButtonsV5$PrimaryButton
};

function ButtonsV5$SecondaryButton(props) {
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
    href: props.href,
    target: props.target,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    disabled: props.disabled,
    size: props.size,
    className: className,
    icon: props.icon,
    overlayText: props.overlayText,
    ariaExpanded: props.ariaExpanded,
    id: props.id,
    _type: props._type,
    children: children,
    appearance: "secondary",
    styleFn: buttonSecondary
  });
}

let SecondaryButton = {
  make: ButtonsV5$SecondaryButton
};

function ButtonsV5$DarkSecondaryButton(props) {
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
    href: props.href,
    target: props.target,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    disabled: props.disabled,
    size: props.size,
    className: className,
    icon: props.icon,
    overlayText: props.overlayText,
    ariaExpanded: props.ariaExpanded,
    id: props.id,
    _type: props._type,
    children: children,
    appearance: "secondary",
    styleFn: buttonDarkSecondary
  });
}

let DarkSecondaryButton = {
  make: ButtonsV5$DarkSecondaryButton
};

function ButtonsV5$CtaButton(props) {
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
    href: props.href,
    target: props.target,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    disabled: props.disabled,
    size: props.size,
    className: className,
    icon: props.icon,
    overlayText: props.overlayText,
    ariaExpanded: props.ariaExpanded,
    id: props.id,
    _type: props._type,
    children: children,
    appearance: "cta",
    styleFn: buttonCta
  });
}

let CtaButton = {
  make: ButtonsV5$CtaButton
};

function ButtonsV5$LinkButton(props) {
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
    href: props.href,
    target: props.target,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    disabled: props.disabled,
    size: props.size,
    className: className,
    icon: props.icon,
    overlayText: props.overlayText,
    ariaExpanded: props.ariaExpanded,
    id: props.id,
    _type: props._type,
    children: children,
    appearance: "link",
    styleFn: buttonLink
  });
}

let LinkButton = {
  make: ButtonsV5$LinkButton
};

function ButtonsV5$Link(props) {
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
    href: props.href,
    target: props.target,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    disabled: props.disabled,
    size: props.size,
    className: className,
    icon: props.icon,
    overlayText: props.overlayText,
    ariaExpanded: props.ariaExpanded,
    id: props.id,
    _type: props._type,
    children: children,
    appearance: "link",
    styleFn: buttonLink
  });
}

let Link$1 = {
  make: ButtonsV5$Link
};

function ButtonsV5$DangerButton(props) {
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
    href: props.href,
    target: props.target,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    disabled: props.disabled,
    size: props.size,
    className: className,
    icon: props.icon,
    overlayText: props.overlayText,
    ariaExpanded: props.ariaExpanded,
    id: props.id,
    _type: props._type,
    children: children,
    appearance: "danger",
    styleFn: buttonDanger
  });
}

let DangerButton = {
  make: ButtonsV5$DangerButton
};

function ButtonsV5$OutlineButton(props) {
  let __color = props.color;
  let __children = props.children;
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let children = __children !== undefined ? __children : null;
  let color = __color !== undefined ? __color : "Default";
  let tmp;
  tmp = color === "Default" ? "text-white disabled:opacity-50 hover:text-zinc-700 hover:bg-white" : "text-tan-blue-500 border-tan-blue-500 hover:text-white hover:bg-tan-blue-500 disabled:opacity-50";
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
    href: props.href,
    target: props.target,
    tabIndex: props.tabIndex,
    onClick: props.onClick,
    onMouseEnter: props.onMouseEnter,
    disabled: props.disabled,
    size: props.size,
    className: TailwindMerge.twMerge([
      tmp,
      className
    ]),
    icon: props.icon,
    overlayText: props.overlayText,
    ariaExpanded: props.ariaExpanded,
    id: props.id,
    _type: props._type,
    children: children,
    appearance: "outline",
    styleFn: buttonOutline
  });
}

let OutlineButton = {
  make: ButtonsV5$OutlineButton
};

let Icon;

exports.Icon = Icon;
exports.Button = Button;
exports.PrimaryButton = PrimaryButton;
exports.SecondaryButton = SecondaryButton;
exports.DarkSecondaryButton = DarkSecondaryButton;
exports.CtaButton = CtaButton;
exports.LinkButton = LinkButton;
exports.DangerButton = DangerButton;
exports.Link = Link$1;
exports.OutlineButton = OutlineButton;
/* buttonBase Not a pure module */
